export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit"])}
      },
      "fr": {
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soumettre"])}
      }
    }
  })
}
